import React, { useEffect, useState } from "react";
import { connect } from 'react-redux';
import RoleForm from "./RoleForm";
import { CircularProgress } from "@material-ui/core";
import * as Yup from "yup";
import * as actions from './store/roleActions';
import History from "../../../History";
import { hasPermission } from "../../sc-utilities";
import { CancelToken } from 'axios';

const RoleCreate = props => {
    const { activeCustomerID, translations, permissions, listPermissions, createRole } = props;
    const [createData, setCreateData] = useState({ permissions: [], loadingData: true });

    useEffect(() => {
        const requestToken = CancelToken.source();
        const fetchData = async () => {
            let permissions = await listPermissions({ ActiveCustomerID: activeCustomerID }, { CancelToken: requestToken.token });
            setCreateData({ permissions: permissions, loadingData: false });
        }
        fetchData();
        return () => {
            requestToken.cancel('Operation canceled by the user.');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const extractPermissions = selectedPermission => {
        return selectedPermission.map(permission => permission.value);
    }

    const isRootCustomer = hasPermission(permissions, 'access_all_roles');

    const handleSubmit = async data => {
        let formData = { ...data };
        formData['CustomerID'] = isRootCustomer && (formData?.Locked || formData?.Type === 'public') ? null : activeCustomerID;
        
        formData['Permissions'] = extractPermissions(data.Permissions);
        let result = await createRole({ ...formData, ActiveCustomerID: activeCustomerID });
        if (result) {
            History.goBack();
        }
    };

    let initialValues = {
        Name: "",
        FancyName: "",
        Type: "private",
        Module: '',
        Locked: false,
        Permissions: [],
    };

    let formSettings = {
        Validation: {
            Name: Yup.string().required("Required"),
            FancyName: Yup.string().required("Required"),
            Type: Yup.string().required("Required"),
            Locked: Yup.boolean().required("Required"),
        },
        FormTitle: translations["create_role"] || "Create role",
        ButtonSubmit: hasPermission(permissions, 'role_create') ? {
            Title: translations["save"] || "SAVE"
        } : null
    };

    return (
        !createData.loadingData ?
            <RoleForm
                formSettings={formSettings}
                initialValues={initialValues}
                handleSubmit={handleSubmit}
                translations={translations}
                permissions={createData.permissions}
            /> :
            <CircularProgress />
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || []
    };
};

const mapDispatchToProps = dispatch => {
    return {
        createRole: data => dispatch(actions.createRole(data)),
        listPermissions: (data, options) => dispatch(actions.loadPermission(data, options)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RoleCreate);
